<div class="company-intro">
    <div class="company-name">
        <h1 style="font-weight: bold;">Seng Hin Rubber (M) Sdn. Bhd.</h1>
        <br><br><br><br>
    </div>

    <div class="company-description">
            <h3>We are one of the top Rubber Manufacturers in Asia.</h3>
            <h3>In terms of quality, price and sustainability. We will never lose to others.</h3>
            <div class="social-section">
                <div class="social-icon-1 col-sm-6" (click)="redirectToFb()"></div>
                <div class="social-icon-2 col-sm-6" (click)="redirectToLink()"></div>
            </div>
    </div>
</div>